import { Group, TableData } from '../models/table-models';
import { TableRequestParams, transformTableResponse } from './data-hooks';
import interceptor from '../restServiceInterceptor';
import { MainGroup } from '../models/user-models';
import { GeoCodingResponse } from '../models/dashboard-models';
import { AxiosRequestHeaders } from 'axios';

export const useGetGroups = (props: TableRequestParams): Promise<TableData<Group[]>> => {
    return interceptor.get('/user-service/api/admin/groups/getAllGroups', {
        params: {
            page: props['pager.page'],
            itemsPerPage: props['pager.itemsPerPage'],
            searchBy: props.filter?.search,
        },
        transformResponse: transformTableResponse,
    });
};
export const useGetAllMainGroups = (): Promise<MainGroup[]> => {
    return interceptor.get('/user-service/api/admin/groups/getAllMainGroups');
};

export const useDeleteGroups = (fields: Group) => {
    return interceptor.post('/user-service/api/admin/groups/deleteGroup', {
        mainGroup: fields.mainGroup,
        subGroup: fields.subGroup,
    });
};

export const useUpdateGroup = (fields: Group, id: number | undefined) => {
    return interceptor.put(`/user-service/api/admin/groups/updateGroup?groupId=${id}`, {
        ...fields,
    });
};

export const useAddGroup = (fields: Group) => {
    return interceptor.post('/user-service/api/admin/groups/addGroup', {
        ...fields,
    });
};

export const useGetAllTimeZones = (): Promise<string[]> => {
    return interceptor.get('/user-service/api/admin/groups/getAllTimezones', { params: { base: 'UTC' } });
};

export const useGeoCoordinates = (address: string, key: string, language: string): Promise<GeoCodingResponse> => {
    return interceptor.get('/maps/api/geocode/json', {
        baseURL: 'https://maps.googleapis.com',
        params: {
            address,
            key,
            language: language,
        },
        transformRequest: [
            (data, headers?: AxiosRequestHeaders) => {
                delete headers?.Authorization;
                return data;
            },
        ],
    });
};
